import { useEffect, useState } from "react"
import {
  getEffectsPresetApi,
  getGenQueueApi,
  getSendHistoryApi,
  sendGiftApi,
} from "src/apis"
import { AssociationInput } from "src/components/AssociationInput"
import { MessagePlugin, Popup } from "tdesign-react"
import "./send_gift_bar.scss"

const QUERY_TASK_DELAY = 1e3

/**
 *  联想词函数
 */
const associationFn: (v: string) => Promise<string[]> = async (v) => {
  const rsp = await getSendHistoryApi({
    GiftPrompt: v,
  })
  return rsp.map((item) => item.PromptText)
}

/**
 * 发送礼物栏
 */
export function SendGiftBar(props: {
  /**
   * 直播间地址
   */
  live_url: string
}) {
  const [effectList, setEffectList] = useState<EffectItem[]>([])
  const [taskQueue, setTaskQueue] = useState<TaskQueueItem[]>([])
  const [sendAvailable, setSendAvail] = useState(true)

  const onSendPresetGift = (id: string) => {
    sendGiftApi({
      InnerPlayAddr: props.live_url,
      PreMadeGiftId: id,
    }).then(() => {
      MessagePlugin.success("发送礼物成功!")
    })
  }

  const onSendGiftByPrompt = (promptText: string) => {
    if (!sendAvailable) {
      MessagePlugin.error("任务队列已满，请稍后再试")
      return
    }

    sendGiftApi({
      InnerPlayAddr: props.live_url,
      GiftPrompt: promptText,
    }).then(() => {
      MessagePlugin.loading("礼物生成中")
    })
  }

  //  获取预设礼物列表
  useEffect(() => {
    getEffectsPresetApi().then((res) => {
      setEffectList(res.EffectPreset)
    })
  }, [])

  //  轮询任务队列
  useEffect(() => {
    const timer = setInterval(() => {
      getGenQueueApi()
        .then((res) => {
          setTaskQueue(res.QueuePromptList)
          setSendAvail(res.IsEnableSend)
        })
        .catch((e) => {
          console.error(e)
          clearInterval(timer)
          setTaskQueue([])
          setSendAvail(true)
          MessagePlugin.error("获取生成任务队列失败: " + e.message)
        })
    }, QUERY_TASK_DELAY)
    return () => {
      clearInterval(timer)
    }
  }, [])

  return (
    <div className="send-gift-bar">
      {taskQueue.length > 0 && (
        <>
          <div className="task-queue">
            {taskQueue.map((item, i) => (
              <Popup key={i} content={item} trigger="hover">
                <div key={i} className="task-item" title={item}>
                  <div className="loading-icon"></div>
                  <span>生成中</span>
                </div>
              </Popup>
            ))}
          </div>
          <div className="divider" />
        </>
      )}
      <div className="preset-gift">
        {effectList.map((item) => (
          <Popup key={item.id} content={item.name} trigger="hover">
            <div
              className="card"
              data-tooltip={item.name}
              onClick={() => onSendPresetGift(item.id)}
            >
              <img src={item.previewImg} alt={item.name} />
            </div>
          </Popup>
        ))}
      </div>
      <div className="gift-prompt-input">
        <AssociationInput
          onSend={(v) => onSendGiftByPrompt(v)}
          defalutValue="生成一辆红色跑车"
          associationFn={associationFn}
          status={"normal"}
        />
      </div>
    </div>
  )
}
